module.exports = __webpack_public_path__ + "img/01-b&r-logo.f905b0f6.png";